import { Controller } from "@hotwired/stimulus"

const formatCurrency = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
}).format

const THEME_CLASSES = {
  gray: ["bg-gray-100", "border-gray-500", "text-gray-600"],
  green: ["bg-green-100", "border-green-500", "text-green-600"],
  orange: ["bg-orange-100", "border-orange-500", "text-orange-600"],
}

const ALL_THEME_CLASSES = Object.values(THEME_CLASSES).flat()

export default class extends Controller {
  static targets = ["unit", "savingsInput"]

  applyTheme(box, theme) {
    box.classList.remove(...ALL_THEME_CLASSES)
    box.classList.add(...THEME_CLASSES[theme])
  }

  computeDiscountedPrice(discountType, base, savings) {
    if (discountType === "rate") return Math.max(0, base * (1 - savings / 100))
    if (discountType === "amount") return Math.max(0, base - savings)
    if (discountType === "special_rate") return Math.min(savings, base)
    return base
  }

  connect() {
    this.update()
  }

  currentDiscountType() {
    return this.element.querySelector(
      'input[name$="[discount_type]"]:checked'
    )?.value
  }

  parsedSavings() {
    if (!this.hasSavingsInputTarget) return null
    const num = parseFloat(this.savingsInputTarget.value)
    return Number.isFinite(num) && num > 0 ? num : null
  }

  update() {
    const savings = this.parsedSavings()
    const discountType = this.currentDiscountType()

    this.unitTargets.forEach((unit) => {
      this.updateUnit(unit, savings, discountType)
    })
  }

  updateUnit(unit, savings, discountType) {
    const basePrice = parseFloat(unit.dataset.basePrice)
    const before = unit.querySelector("[data-preview-before]")
    const afterWrapper = unit.querySelector("[data-preview-after]")
    const afterBox = afterWrapper?.firstElementChild
    const discountedEl = unit.querySelector("[data-preview-discounted-price]")
    if (!before || !afterBox || !discountedEl) return

    const showPreview =
      savings !== null &&
      discountType &&
      Number.isFinite(basePrice) &&
      basePrice > 0

    if (!showPreview) {
      before.classList.add("hidden")
      this.applyTheme(afterBox, "gray")
      discountedEl.textContent = formatCurrency(basePrice)
      return
    }

    const newPrice = this.computeDiscountedPrice(discountType, basePrice, savings)
    before.classList.remove("hidden")
    this.applyTheme(afterBox, newPrice < basePrice ? "green" : "orange")
    discountedEl.textContent = formatCurrency(newPrice)
  }
}
